// Statistics routes
export default [{
  path: 'statistics',
  name: 'Statistics',
  meta: {
    title: 'navbar.statistics',
  },
  component: () => import(/* webpackChunkName: "statistics" */ '../views/statistics/Statistics.vue'),
}];
